const lazyForSmallBusinessPageComponent = () => import('@/Pages/En/ForCompanies/Developers.vue');
const lazyForRealEstateManagement = () => import('@/Pages/En/ForCompanies/RealEstateManagement.vue');
const lazyForMarketingPageComponent = () => import('@/Pages/En/ForCompanies/ForMarketing.vue');

export const forCompaniesRoutes = [
  {
    path: '/developers',
    name: 'developers',
    component: lazyForSmallBusinessPageComponent,
    meta: {
      name: 'developers',
      title: 'Developers - Integrate AI Floor Plans',
    },
  },
  {
    path: '/real-estate-management',
    name: 'real-estate-management',
    component: lazyForRealEstateManagement,
    meta: {
      name: 'real-estate-management',
      title: 'Real Estate Management - AI Floor Plans Solutions',
    },
  },
  {
    path: '/marketing',
    name: 'marketing',
    component: lazyForMarketingPageComponent,
    meta: {
      name: 'marketing',
      title: 'Marketing - Promote with AI-Generated Floor Plans',
    },
  },
];
